<form
  [formGroup]="form"
  NfFormValidation
  (validSubmit)="onSubmit()"
  data-cy="form"
>
  <div class="modal-header" hsDraggable="modal-dialog">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button
      nf-icon-button="cancel"
      icon="close"
      class="btn-bare"
      ngbTooltip="Close"
      (click)="onCancel()"
    ></button>
  </div>
  <div class="modal-body" hsDraggable="modal-dialog">
    <div class="toggle-row" [class.cautions-below]="hasCautions">
      <div class="toggle-block">
        <div class="control-label">Existing codes</div>
        <nf-toggle
          class="segment-toggle"
          data-cy="edit-note-keep-toggle"
          [states]="{ on: 'Override', off: 'Keep' }"
          [ngModel]="keepControl.value === 'override'"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="keepControl.setValue($event ? 'override' : 'keep')"
        ></nf-toggle>
      </div>
      <div class="toggle-block">
        <div class="control-label">Note handling</div>
        <nf-toggle
          class="segment-toggle"
          data-cy="note-handling-toggle"
          [states]="{ on: 'Append', off: 'Override' }"
          [ngModel]="noteHandlingControl.value === 'append'"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="
            noteHandlingControl.setValue($event ? 'append' : 'override')
          "
        ></nf-toggle>
      </div>
      <button
        nf-icon-button="secondary"
        icon="content-paste"
        class="btn-bare paste-break-codes-btn"
        type="button"
        data-cy="paste-break-codes"
        [disabled]="!canPaste"
        ngbTooltip="Paste Break Codes (Alt+V)"
        (click)="onPasteBreakCodes()"
      ></button>
    </div>

    <div
      *ngIf="hasCautions"
      class="dialog-caution"
      data-cy="edit-note-keep-caution"
    >
      Your codes won't apply to {{ keepBlockedCodeCount }} break{{
        keepBlockedCodeCount === 1 ? '' : 's'
      }}
      with a different existing code. Switch to Override to replace them.
    </div>

    <div [formGroup]="editForm">
      <ng-container
        *ngIf="
          actionItems.length > 0 || descriptionItems.length > 0;
          else codesEmpty
        "
      >
        <div class="field-row">
          <nf-form-control
            *ngIf="actionItems.length > 0"
            label="Action"
            compact
          >
            <ng-select
              [items]="actionItems"
              placeholder="Select Action"
              formControlName="action"
              [closeOnSelect]="true"
              data-cy="edit-note-action"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item
                }}<span
                  *ngIf="notesRequiredActionCodeSet.has(item)"
                  class="notes-required-diamond"
                >
                  ◆</span
                >
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div [ngbTooltip]="item" container="body" class="ellipsis">
                  {{ item
                  }}<span
                    *ngIf="notesRequiredActionCodeSet.has(item)"
                    class="notes-required-diamond"
                  >
                    ◆</span
                  >
                </div>
              </ng-template>
            </ng-select>
          </nf-form-control>

          <nf-form-control
            *ngIf="descriptionItems.length > 0"
            label="Description"
            compact
          >
            <ng-select
              [items]="descriptionItems"
              placeholder="Select Description"
              formControlName="description"
              [closeOnSelect]="true"
              data-cy="edit-note-description"
            >
              <ng-template ng-option-tmp let-item="item">
                <div [ngbTooltip]="item" container="body" class="ellipsis">
                  {{ item }}
                </div>
              </ng-template>
            </ng-select>
          </nf-form-control>
        </div>
      </ng-container>

      <ng-template #codesEmpty>
        <div
          *ngIf="!editNoteVal.codeRequiredButUnavailable"
          class="edit-note-codes-empty"
          data-cy="edit-note-codes-empty"
        >
          No break codes apply to this selection — you can still edit the note.
        </div>
      </ng-template>

      <!-- Narrow-selection guidance: shown whenever a required field has no
             common code, even if the other field still offers options. -->
      <div
        *ngIf="editNoteVal.codeRequiredButUnavailable"
        class="edit-note-codes-empty"
        data-cy="edit-note-codes-narrow"
      >
        {{ editNoteVal.reason }}
      </div>

      <nf-form-control
        label="Note"
        for="editNoteFormControl"
        [customErrorMessages]="noteValidationMessages"
      >
        <textarea
          class="form-control"
          id="editNoteFormControl"
          rows="4"
          formControlName="note"
          placeholder="Leave blank to keep each break's existing note."
          data-cy="edit-note-note"
        ></textarea>
      </nf-form-control>
    </div>
  </div>
  <div class="modal-footer" hsDraggable="modal-dialog">
    <span
      *ngIf="editNoteVal.reason"
      class="save-disabled-reason"
      data-cy="edit-note-save-reason"
    >
      {{ editNoteVal.reason }}
    </span>
    <button nf-button="cancel" (click)="onCancel()"></button>
    <span
      [ngbTooltip]="editNoteVal.reason"
      container="body"
      class="d-inline-block"
    >
      <button
        nf-button="submit"
        data-cy="edit-note-save"
        [loading]="formSubmitting"
        [disabled]="formSubmitting || editNoteVal.submitDisabled"
      >
        {{ saveBtnLabel }}
      </button>
    </span>
  </div>
</form>
